<template>
    <span>{{ roundedValue }}{{ value.unit }}</span>
</template>

<script>
export default {
    props: {
        value: Object,
        decimals: {
            type: Number,
            default: null
        }
    },

    computed: {
        roundedValue() {
            if (this.decimals === null) {
                return this.value.value;
            }

            return parseFloat(this.value.value).toFixed(this.decimals)
        }
    }
}
</script>
